"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryCodeToAmazonRegion = exports.amazonMarketplaceIdByCurrency = exports.amazonMarketplaceIdByHost = exports.amazonCountry = exports.marketplace = void 0;
const mwsConstants_1 = require("./mwsConstants");
const marketplace = (countryCode) => {
    const site = mwsConstants_1.amazonSites[countryCode];
    if (site == null)
        throw new Error(`No Amazon site corresponding to country ${countryCode}`);
    return site;
};
exports.marketplace = marketplace;
const amazonCountry = (marketplaceId) => {
    for (const country in mwsConstants_1.amazonSites) {
        if (mwsConstants_1.amazonSites[country].marketplaceId === marketplaceId) {
            return country;
        }
    }
    throw new Error(`Marketplace ID ${marketplaceId} does not correspond to any known Amazon sites`);
};
exports.amazonCountry = amazonCountry;
const amazonMarketplaceIdByHost = (retailHost) => {
    const host = retailHost.toLowerCase();
    for (const country in mwsConstants_1.amazonSites) {
        if (mwsConstants_1.amazonSites[country].retailHost === host) {
            return mwsConstants_1.amazonSites[country].marketplaceId;
        }
    }
    throw new Error(`retailHost ${retailHost} does not correspond to any known Amazon sites`);
};
exports.amazonMarketplaceIdByHost = amazonMarketplaceIdByHost;
const amazonMarketplaceIdByCurrency = (currency) => {
    for (const country in mwsConstants_1.amazonSites) {
        if (mwsConstants_1.amazonSites[country].uniqueCurrency === currency) {
            return mwsConstants_1.amazonSites[country].marketplaceId;
        }
    }
};
exports.amazonMarketplaceIdByCurrency = amazonMarketplaceIdByCurrency;
const countryCodeToAmazonRegion = (countryCode) => {
    if (mwsConstants_1.regionalCountryCodes.NA.includes(countryCode)) {
        return "na";
    }
    else if (mwsConstants_1.regionalCountryCodes.EU.includes(countryCode)) {
        return "eu";
    }
    else if (mwsConstants_1.regionalCountryCodes.AP.includes(countryCode)) {
        return "fe";
    }
    throw new Error("countryCodeToAmazonRegion: unrecognised country code");
};
exports.countryCodeToAmazonRegion = countryCodeToAmazonRegion;
//# sourceMappingURL=mwsUtils.js.map